'use client';

import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';

import tabsStyles from '@/blocks/components/Controls/Tabs/styles.module.scss';
import { DeprecatedTabsOverflowContainer } from '@/blocks/components/DeprecatedTabs';
import { useCreateTabs } from '@/hooks/useCreateTabs';
import { EventBlockNames } from '@/providers/analytics/types';

import { CryptoFuturesFeesAdvantagesTabContent } from './CryptoFuturesFeesAdvantagesTabContent';

export enum AdvantagesTabs {
  ACCOUNT = 'account',
  DEPOSITS_WITHDRAWALS = 'depositsWithdrawals',
  TRADING = 'trading',
}

export const CryptoFuturesFeesAdvantagesSection = () => {
  const { tabs, selectedTab, setSelectedTab } = useCreateTabs(
    [AdvantagesTabs.TRADING, AdvantagesTabs.DEPOSITS_WITHDRAWALS, AdvantagesTabs.ACCOUNT],
    'pages.cryptoFutures.fees.sections.advantages',
  );

  return (
    <section data-event-block-name={EventBlockNames.fees}>
      <DeprecatedTabsOverflowContainer>
        <Tabs
          variant={'scrollable'}
          value={selectedTab}
          onChange={(_, val) => setSelectedTab({ value: val })}
          scrollButtons={false}
          className={tabsStyles.tabs}
        >
          {tabs.map(({ value, label }) => (
            <Tab key={value} value={value} disableRipple label={label} />
          ))}
        </Tabs>
      </DeprecatedTabsOverflowContainer>
      <CryptoFuturesFeesAdvantagesTabContent selectedTab={selectedTab as AdvantagesTabs} />
    </section>
  );
};
